var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconRemoveLinkSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconRemoveLink",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M614.742 795.026c61.932.36 119.783 24.965 163.11 69.373L605.98 1032.071c1.44 1.32 4.081 3 7.322 3l-369.67 373.392 267.89 267.77 375.312-375.31 168.752-158.79c44.288 43.207 68.893 101.178 69.257 162.99.356 62.412-23.889 121.103-68.297 165.512l-381.793 381.912c-43.568 43.448-101.54 67.453-163.23 67.453-61.813 0-119.784-24.005-163.232-67.453L67.438 1571.694c-89.897-90.017-89.897-236.445-.12-326.462L449.23 863.319c44.049-44.048 102.26-68.293 164.192-68.293Zm764.305 706.118v360.069h-120.023v-360.069h120.023Zm222.402 17.56 240.046 240.045-84.856 84.856-240.046-240.045 84.856-84.856Zm257.69-257.605v120.023h-360.07v-120.023h360.07ZM1245.497 67.184c89.177-89.177 235.725-89.657 326.582-.96l280.733 280.733c89.537 91.938 89.177 238.245 0 327.542L1470.9 1056.172c-43.329 43.448-101.42 67.573-163.231 67.573-61.692 0-119.663-24.125-163.111-67.573L1314.27 886.46c-3.12-3.121-10.082-3.121-13.083 0L1683.1 504.667l-279.893-267.77-369.55 381.552c3.48-3.841 3.36-9.122-.24-12.843L863.704 775.318c-90.017-90.017-90.017-236.324 0-326.342ZM408.543 540.962v120.023H68.998V540.962h339.545ZM658.91 71.072v339.425H538.767V71.073H658.91ZM161.092 78.43l240.165 240.046-84.856 84.856L76.356 163.286l84.736-84.856Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconRemoveLinkSolid.glyphName = 'remove-link';
IconRemoveLinkSolid.variant = 'Solid';
IconRemoveLinkSolid.displayName = 'IconRemoveLinkSolid';
IconRemoveLinkSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconRemoveLinkSolid;
export { IconRemoveLinkSolid };